import useSharedSidebarProducts from './useSharedSidebarProducts';
/**
 *
 * @param {number} productID The app/product ID.
 * @param {Array} appProducts Top menu products that are merged with the sidebar on mobile.
 */
export default function useSidebarProducts(productID, appProducts = []) {
  const products = useSharedSidebarProducts();
  return products.map(product => ({
    ...product,
    url: product.navigationID === productID ? '/' : product.url,
    children: product.navigationID === productID ? appProducts : []
  }));
}
